import { useCheckPermissions } from "@app/hooks/useCheckPermissions";
import { Permission } from "@app/common";

interface Props {
  permissions: Permission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const CheckPermissions = ({ permissions, children, fallback = null }: Props) => {
  const checkPermissions = useCheckPermissions()

  if (!checkPermissions(permissions)) {
    return fallback;
  }

  return children
};
